import React from "react";

import {
  Card,
  CardContent,
} from "@replo/design-system/components/shadcn/core/card";

const LoadingVersionCard: React.FC = () => (
  <Card className="w-[400px] max-w-full p-0 mb-3">
    <CardContent className="flex flex-col items-start gap-2 p-4">
      <div className="flex flex-row gap-3 items-start">
        <div className="flex flex-col gap-1">
          <div className="text-base font-semibold">Loading...</div>
          <div className="text-sm text-muted relative pb-8">
            Loading the version...
          </div>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default LoadingVersionCard;
